import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { useQuery } from '@tanstack/react-query';
import { useCompanyContext } from '../../../../context/CompanyContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { fecthJCCostEstimate } from '../../../../services/accounting/JobsContractsService';
import JCCEDrilldown from './JCCEDrilldown';

type JCCEDrilldownContainerProps = {
  visible: boolean;
  hideDrilldown: () => void;
  contract: string;
  contractName: string;
};

const JCCEDrilldownContainer = ({
  visible,
  hideDrilldown,
  contract,
  contractName,
}: JCCEDrilldownContainerProps) => {
  const { selectedCompany } = useCompanyContext();

  const { data, isFetching, isError, isSuccess } = useQuery({
    queryKey: ['getJCCostEstimateDrilldown', selectedCompany, contract],
    queryFn: ({ signal }) =>
      fecthJCCostEstimate(
        {
          companyID: selectedCompany!.id,
          job: contract,
        },
        signal
      ),
    refetchOnWindowFocus: false,
    enabled: !!selectedCompany,
  });

  return (
    <Sidebar
      visible={visible}
      position="right"
      onHide={hideDrilldown}
      className="w-full max-w-1500px"
    >
      {isFetching && (
        <div className="mx-8 h-full flex align-items-center">
          <ProgressSpinner />
        </div>
      )}
      {isError && (
        <div className="h-full flex align-items-center">
          <ErrorMessage
            content={'Failed to obtain data! Please try again later.'}
          />
        </div>
      )}
      {isSuccess && (
        <JCCEDrilldown
          estimates={data}
          contract={contract}
          contractName={contractName}
        />
      )}
    </Sidebar>
  );
};

export default JCCEDrilldownContainer;
